import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
// const baseUrl = 'http://dev02:8080';

const service = 'bitvavo';

class Pnl3Service extends ServiceBase {
    /**
     * Fetches the Realized/Unrealized/Verdict summary for one asset.
     * @param {number|string} sid
     * @returns {Promise}
     */
    getSummary = (sid) => {
        const url = `${baseUrl}/${service}/pnl3/balance/summary?sid=${sid}`;
        const cfg = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, cfg);
    };

    getMatched = (sid) => {
        const url = `${baseUrl}/${service}/pnl3/matched?sid=${sid}`;
        const cfg = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, cfg);
    };

    getUnmatched = (sid) => {
        const url = `${baseUrl}/${service}/pnl3/unmatched?sid=${sid}`;
        const cfg = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, cfg);
    };

    getOrders = (sid, start = 0, end = 0) => {
        const url = `${baseUrl}/${service}/pnl3/orders?sid=${sid}&start=${start}&end=${end}`;
        const cfg = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, cfg);
    };
}

const pnl3Service = new Pnl3Service();
export default pnl3Service;
